import React from 'react';
import PickingPerformanceTable from './table/PickingPerformanceTable';
import PickingPerformanceExport from './export/PickingPerformanceExport';
import { Row, Column } from '@ydistri/ds';

const PickingPerformance: React.FC = () => {
  return (
    <Column $gap="1rem" $flexGrow={1}>
      <Row $justifyContent="right">
        <PickingPerformanceExport />
      </Row>
      <PickingPerformanceTable />
    </Column>
  );
};

export default PickingPerformance;
